import { Language, useTranslations } from "@gf-easy-8/grmnext-foundation";
import { FunctionComponent, useEffect } from "react";
import { getLanguageFromLocalStorage } from "../provider/TranslationProvider/translations";

const Listeners: FunctionComponent = () => {
  const { setCurrentLanguage } = useTranslations();

  useEffect(() => {
    const language = getLanguageFromLocalStorage();
    setCurrentLanguage((language as Language) || "en");
  }, [setCurrentLanguage]);

  return null;
};

export default Listeners;
